import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/` → redirect to /dashboard.
 *
 * Mounted under `_authed`, so the redirect only fires for signed-in
 * users; an unauthed visitor hits `_authed.beforeLoad` first and
 * bounces to /login.
 */
export const Route = createFileRoute('/_authed/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
